<template>
    <div id="app">
        <Header></Header>
        <router-view />
        <Loading v-if="loading"></Loading>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import Loading from '@/components/Loading/Loading.vue';
import Header from '@/components/Header/Header.vue';

export default {
    components: { Header, Loading },
    computed: {
        ...mapState('loading', ['loading']),
    },
};
</script>

<style lang="scss">
* {
    font-family: Arial, Helvetica, sans-serif;
}
</style>
